var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarBugLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150",
      fill: "#010b6c"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M75,96.4H58.8V84.3H75V72.9H58.8V60.8H75V26.6c-5.9,0-11.5,1.9-16.4,5.2L48.1,19.4l-8.4,7.1l10.7,12.6 c-3.8,4.5-7,10-9.3,16.2H26.2v11h11.9c-0.4,2.2-0.7,4.5-0.9,6.8h-11v11h11c0.2,2.3,0.5,4.6,0.9,6.8H26.2v11H41 c6.3,17,19.1,28.7,34,28.7V96.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M123.8,55.3H109c-2.3-6.2-5.5-11.8-9.3-16.2l10.7-12.6l-8.4-7.1L91.4,31.8c-5-3.3-10.5-5.2-16.4-5.2v34.1h16.2v12.1H75 v11.4h16.2v12.1H75v34.2c14.9,0,27.7-11.7,34-28.7h14.9v-11h-11.9c0.4-2.2,0.7-4.5,0.9-6.8h11v-11h-11c-0.2-2.3-0.5-4.6-0.9-6.8 h11.9V55.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBugLine);
export default __webpack_public_path__ + "static/media/SidebarBugLine.b2c7378952575e4bc66544e763b0cca7.svg";
export { ForwardRef as ReactComponent };